export default "__VITE_ASSET__rjwYvYF6__"